import { createFileRoute, redirect } from '@tanstack/react-router';

// Profile moved to /user; /account has no landing page of its own, so the
// section opens on Team (the first account-level thing you'd manage).
export const Route = createFileRoute('/account/')({
  beforeLoad: () => {
    throw redirect({ to: '/account/team', replace: true });
  },
});
